import React from "react";
import { Box, Typography } from "@mui/joy";

const types = [
  {
    label: "H.R. / S.",
    title: "Bills",
    description:
      "The most common form of legislation. A bill proposes a new law or changes an existing one, and can be temporary or permanent in scope.",
    points: [
      "House bills are labeled H.R.; Senate bills are labeled S.",
      "Both chambers must pass the identical text before it goes to the President.",
      "Once signed, it becomes a Public Law with a permanent citation.",
    ],
  },
  {
    label: "H.J.Res. / S.J.Res.",
    title: "Joint Resolutions",
    description:
      "Nearly identical to bills in process and legal effect. Most commonly used for constitutional amendments and emergency measures.",
    points: [
      "Constitutional amendments require a two-thirds vote in both chambers.",
      "The President does not sign constitutional amendments — they go directly to the states.",
      "Three-fourths of states must ratify before an amendment takes effect.",
    ],
  },
  {
    label: "H.Con.Res. / S.Con.Res.",
    title: "Concurrent Resolutions",
    description:
      "Express the sense of Congress on a matter or handle internal business affecting both chambers. They do not have the force of law.",
    points: [
      "Used to set the federal budget framework or adjourn Congress.",
      "Must pass both chambers but does not require the President's signature.",
      "Cannot create, amend, or repeal statutory law.",
    ],
  },
  {
    label: "H.Res. / S.Res.",
    title: "Simple Resolutions",
    description:
      "Govern the internal operations of a single chamber or express that chamber's opinion on a matter. They carry no legal weight outside of Congress.",
    points: [
      "Used to establish rules, create committees, or censure members.",
      "Only the originating chamber votes on them.",
      "The President has no role — these never leave their chamber of origin.",
    ],
  },
];

const TypesOfLegislation = () => {
  return (
    <Box sx={{ borderTop: "1px solid rgba(0,0,0,0.07)", backgroundColor: "white" }}>
      <Box
        sx={{
          maxWidth: "1200px",
          mx: "auto",
          px: { xs: "1.25rem", md: "2rem" },
          py: { xs: "3.5rem", md: "5rem" },
        }}
      >
        {/* Section header */}
        <Box sx={{ mb: { xs: "2.5rem", md: "3.5rem" } }}>
          <Typography
            component="p"
            sx={{
              fontSize: "11px",
              fontWeight: 700,
              color: "#0075b2",
              textTransform: "uppercase",
              letterSpacing: "0.12em",
              mb: "10px",
            }}
          >
            Reference
          </Typography>
          <Typography
            level="h2"
            sx={{
              fontSize: { xs: "28px", md: "36px" },
              fontWeight: 700,
              color: "#171a1c",
              lineHeight: 1.2,
              maxWidth: "480px",
            }}
          >
            Types of Legislation
          </Typography>
        </Box>

        {/* Grid */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: "1px",
            backgroundColor: "rgba(0,0,0,0.07)",
            border: "1px solid rgba(0,0,0,0.07)",
            borderRadius: "4px",
            overflow: "hidden",
          }}
        >
          {types.map((type, index) => (
            <Box
              key={index}
              sx={{
                backgroundColor: "#fff",
                padding: { xs: "1.75rem", md: "2rem 2.25rem" },
              }}
            >
              <Typography
                component="p"
                sx={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: "#0075b2",
                  letterSpacing: "0.06em",
                  mb: "8px",
                  fontFamily: "monospace",
                }}
              >
                {type.label}
              </Typography>
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#171a1c",
                  mb: "10px",
                  lineHeight: 1.25,
                }}
              >
                {type.title}
              </Typography>
              <Typography
                sx={{
                  fontSize: "15px",
                  color: "#535862",
                  lineHeight: 1.65,
                  mb: "14px",
                }}
              >
                {type.description}
              </Typography>
              <Box
                component="ul"
                sx={{
                  margin: 0,
                  paddingLeft: "18px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                }}
              >
                {type.points.map((point, i) => (
                  <Box
                    key={i}
                    component="li"
                    sx={{
                      fontSize: "14px",
                      color: "#6b7280",
                      lineHeight: 1.6,
                    }}
                    dangerouslySetInnerHTML={{ __html: point }}
                  />
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default TypesOfLegislation;
